/**
 * Animación imperativa: clona la imagen del producto y la hace volar hasta
 * el ícono del carrito (data-testid="header-cart-btn"). Sin libs externas.
 *
 * Duración 1.6s, trayectoria parabólica alta + leve rotación + halo rosa.
 * Visible y notoria sin ser molesta.
 *
 * @param {HTMLImageElement|HTMLElement} sourceEl - elemento origen (imagen del producto)
 */
export function flyToCart(sourceEl) {
  if (!sourceEl) return;
  const target = document.querySelector('[data-testid="header-cart-btn"]');
  if (!target) return;

  const src = sourceEl.getBoundingClientRect();
  const dst = target.getBoundingClientRect();

  const imgUrl = sourceEl.tagName === 'IMG'
    ? sourceEl.src
    : (sourceEl.querySelector('img')?.src || '');

  // Tamaño inicial: mantenemos el ancho real (hasta 140px) para que sea muy visible
  const startSize = Math.min(Math.max(src.width, 96), 140);

  const clone = document.createElement('div');
  clone.style.cssText = `
    position: fixed;
    left: ${src.left + src.width / 2 - startSize / 2}px;
    top: ${src.top + src.height / 2 - startSize / 2}px;
    width: ${startSize}px;
    height: ${startSize}px;
    border-radius: 9999px;
    background: ${imgUrl ? `url(${imgUrl}) center/cover no-repeat` : '#F9A8D4'};
    box-shadow:
      0 0 0 4px rgba(255, 255, 255, 0.85),
      0 0 28px 6px rgba(244, 114, 182, 0.55),
      0 18px 40px -10px rgba(244, 114, 182, 0.5);
    z-index: 9999;
    pointer-events: none;
    will-change: transform, opacity;
    transition: none;
  `;
  document.body.appendChild(clone);

  const dx = dst.left + dst.width / 2 - (src.left + src.width / 2);
  const dy = dst.top + dst.height / 2 - (src.top + src.height / 2);

  // Parabólica: en el medio sube un poco antes de caer al carrito
  const liftY = Math.min(Math.abs(dy) * 0.4 + 60, 200);

  const anim = clone.animate(
    [
      { transform: 'translate(0, 0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
      { transform: `translate(${dx * 0.35}px, ${dy * 0.25 - liftY}px) scale(0.85) rotate(-12deg)`, opacity: 1, offset: 0.35 },
      { transform: `translate(${dx * 0.7}px, ${dy * 0.55 - liftY * 0.4}px) scale(0.55) rotate(8deg)`, opacity: 0.95, offset: 0.65 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.12) rotate(20deg)`, opacity: 0, offset: 1 },
    ],
    { duration: 1600, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
  );
  anim.onfinish = () => clone.remove();
  anim.oncancel = () => clone.remove();

  // Bounce del ícono del carrito justo cuando el clon "aterriza"
  setTimeout(() => {
    if (!target) return;
    target.classList.remove('cart-bounce');
    void target.offsetWidth; // force reflow para reiniciar la animación
    target.classList.add('cart-bounce');
    setTimeout(() => target.classList.remove('cart-bounce'), 700);
  }, 1450);
}
